<template>
  <v-card outlined tile class="ma-3 pa-0 align-start">
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Наименование</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROP_NAME" dense :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Код</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="PROP_CODE" dense :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Ед. изм.</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field :value="EI.EI_NAME" dense readonly >
          <template v-slot:append v-if="mode=='editor'">
            <v-icon small @click="callSelectEI"> mdi-plus-circle-multiple-outline </v-icon>
          </template>
        </v-text-field>
      </v-card>
    </v-card>
    <ref-org-e-i-select-dialog :e-i="[EI]" v-model="showSelectEI" @onEIChanged="setEI"></ref-org-e-i-select-dialog>
  </v-card>
</template>

<script>

import refOrgEISelectDialog from '@/components/modules/references/dialogs/refSelectOrgEI'
export default {
  name: 'refPropCard',
  components: { refOrgEISelectDialog },
  props: ['prop', 'mode'],
  data () {
    return {
      showSelectEI: false
    }
  },
  computed: {
    PROP_NAME: {
      get () {
        return this.prop ? this.prop.PROP_NAME : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { PROP_NAME: val })
      }
    },
    PROP_CODE: {
      get: function () {
        return this.prop ? this.prop.PROP_CODE : ''
      },
      set (val) {
        this.$emit('onPropUpdate', { PROP_CODE: val })
      }
    },
    EI: {
      get: function () {
        console.log('getting EI. current prop is ', this.prop)
        return this.prop ? this.prop.EI ? this.prop.EI : { EI_NAME: 'нет' } : { EI_NAME: 'нет' }
      },
      set (val) {
        this.$emit('onPropUpdate', { EI: val })
      }
    }
  },
  methods: {
    callSelectEI () {
      this.showSelectEI = true
    },
    setEI (val) {
      console.log('Setting EI to ', val)
      this.EI = val
    }
  },
  mounted () {
    console.log('refPropCard mounted in mode ', this.mode, ' with Property ', this.prop)
  }
}
</script>
